import { Button, Stack } from "@mui/material";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { CommonContainerPropsComponent } from "../../../api/content-client/service";

interface Props {
  buttonPrimaryLink?: string;
  buttonPrimaryTitle?: string;
  buttonSecondaryLink?: string;
  buttonSecondaryTitle?: string;
  containerProps?: CommonContainerPropsComponent;
}

export function ContentRendererButtonBlock(block: Props) {
  const {
    buttonPrimaryLink,
    buttonPrimaryTitle,
    buttonSecondaryLink,
    buttonSecondaryTitle,
    containerProps,
  } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <Stack
        direction="column"
        spacing={2}
        sx={{ textAlign: "center", height: "100%" }}
        alignItems="center"
      >
        <Stack spacing={2} direction={{ xs: "column", sm: "row" }}>
          {buttonPrimaryLink ?
            <Button
              href={buttonPrimaryLink}
              size="large"
              variant="contained"
              color="primary"
            >
              {buttonPrimaryTitle}
            </Button> : null}

          {buttonSecondaryLink ?
            <Button
              href={buttonSecondaryLink}
              size="large"
              variant="outlined"
              color="secondary"
            >
              {buttonSecondaryTitle}
            </Button> : null}
        </Stack>
      </Stack>
    </ContentRendererContainer>
  );
}
